import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  @media all and (max-width: 850px){\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { baseColors, darkColors, lightColors } from "../../theme/colors";
import { WavaxIcon, Text } from "@pancakeswap/uikit";
import { Flex } from "../Box";
import { Link } from "../Link";
import { StyledFooter, StyledList, StyledListItem, StyledText, StyledSocialLinks, FixedFooter, FooterItem } from "./styles";
import { useAvaxUsdcPrice } from "hooks/useUSDCPrice";
import RPCIndicator from "components/RPCIndicator";
// import Logo from "../../widgets/Menu/components/Logo";
// import { ThemeSwitcher } from "../ThemeSwitcher";
// import LangSelector from "../LangSelector/LangSelector";
// import CakePrice from "../CakePrice/CakePrice";
// import { LogoWithTextIcon, ArrowForwardIcon } from "../Svg";
// import { Button } from "../Button";
// import { Colors } from "../..";
// import lightTheme from "../../theme/light";
var LgWindowSpacer = styled.div.withConfig({
    componentId: "sc-6a3faecc-0"
})(_templateObject());
var FooterMenu = function(_param) {
    var items = _param.items, isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, cakePriceUsd = _param.cakePriceUsd, buyCakeLabel = _param.buyCakeLabel, props = _object_without_properties(_param, [
        "items",
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang",
        "cakePriceUsd",
        "buyCakeLabel"
    ]);
    var avaxUsdcPrice = useAvaxUsdcPrice();
    var avaxUsdcPriceValue = avaxUsdcPrice ? avaxUsdcPrice.toFixed(2) : "";
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(StyledFooter, _object_spread_props(_object_spread({
                p: [
                    "40px 16px",
                    null,
                    "56px 24px 32px 24px"
                ]
            }, props), {
                justifyContent: "center",
                children: /*#__PURE__*/ _jsxs(Flex, {
                    flexDirection: "column",
                    width: [
                        "100%",
                        null,
                        null,
                        "1632px"
                    ],
                    children: [
                        /*#__PURE__*/ _jsxs(Flex, {
                            order: [
                                2,
                                null,
                                1
                            ],
                            flexDirection: [
                                "column",
                                null,
                                null,
                                "row"
                            ],
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            mb: [
                                "42px",
                                null,
                                "36px"
                            ],
                            children: [
                                items === null || items === void 0 ? void 0 : items.map(function(item) {
                                    var ref;
                                    /*#__PURE__*/ return _jsxs(StyledList, {
                                        children: [
                                            /*#__PURE__*/ _jsx(StyledListItem, {
                                                children: item.label
                                            }),
                                            (ref = item.items) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                                var label = param.label, href = param.href, _isHighlighted = param.isHighlighted, isHighlighted = _isHighlighted === void 0 ? false : _isHighlighted, openInNewTab = param.openInNewTab;
                                                return /*#__PURE__*/ _jsx(StyledListItem, {
                                                    children: href ? /*#__PURE__*/ _jsx(Link, {
                                                        href: href,
                                                        target: openInNewTab ? "_blank" : "_self",
                                                        rel: "noreferrer noopener",
                                                        color: isHighlighted ? baseColors.success : isDark ? darkColors.textSubtle : lightColors.textSubtle,
                                                        bold: false,
                                                        children: label
                                                    }) : /*#__PURE__*/ _jsx(StyledText, {
                                                        children: label
                                                    })
                                                }, label);
                                            })
                                        ]
                                    }, item.label);
                                }),
                                /*#__PURE__*/ _jsx(LgWindowSpacer, {}),
                                /*#__PURE__*/ _jsx(LgWindowSpacer, {})
                            ]
                        }),
                        /*#__PURE__*/ _jsx(StyledSocialLinks, {
                            order: 2,
                            pb: [
                                "42px",
                                null,
                                "32px"
                            ],
                            mb: [
                                "12px",
                                null,
                                "48px",
                                "48px"
                            ]
                        })
                    ]
                })
            })),
            /*#__PURE__*/ _jsxs(FixedFooter, {
                p: [
                    "0 16px",
                    null,
                    "0 24px 0 24px"
                ],
                children: [
                    /*#__PURE__*/ _jsx(FooterItem, {
                        children: /*#__PURE__*/ _jsxs(Text, {
                            color: "textSubtle",
                            children: [
                                /*#__PURE__*/ _jsx(WavaxIcon, {
                                    style: {
                                        width: "12px",
                                        margin: "1px 5px -1px 4px"
                                    }
                                }),
                                "$",
                                avaxUsdcPriceValue ? avaxUsdcPriceValue : "--.--"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(FooterItem, {
                        children: /*#__PURE__*/ _jsx(RPCIndicator, {})
                    })
                ]
            })
        ]
    });
};
export default FooterMenu;
